import { Button, Col, Form, Input, Modal, Row, Select, Space } from "antd";
import { DOCK_TYPES } from "../../../common/constants";

function StationModal({
  open = false,
  onSave = () => {},
  onCancel = () => {},
  data = {},
  isUpdate = false,
  campuses = [],
}) {
  return (
    <Modal
      title={isUpdate ? "Update Dock Station" : "Add Dock Station"}
      centered
      width={900}
      visible={open}
      onCancel={onCancel}
      footer={null}
    >
      <Form
        layout="vertical"
        onFinish={(values) => {
          values.id_campus = values.campus.value;
          values.status = values.status.value;
          values.station_type = values.station_type.value;
          let latlong = values.latlong.split(",");
          delete values.campus;
          delete values.latlong;
          values.latitude = latlong[0];
          values.longitude = latlong[1];
          onSave(values);
        }}
        initialValues={
          Object.keys(data).length
            ? {
                ...data,
                campus: {
                  label: data.campus.name,
                  value: data.campus.id,
                },
                latlong: data.latitude
                  ? data.latitude + "," + data.longitude
                  : "",
                status: { label: data.status, value: data.status },
                station_type: {
                  label: data.station_type,
                  value: data.station_type,
                },
              }
            : {
                status: { label: "active", value: "active" },
                station_type: DOCK_TYPES.Other,
              }
        }
      >
        <Row gutter={24}>
          <Col span={12}>
            <Form.Item
              label="Dock Name (full location)"
              name="name"
              rules={[
                {
                  required: true,
                  message: "Please Dock Name",
                },
              ]}
            >
              <Input placeholder="Dock Name" />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              label="Dock Code (short name)"
              name="code"
              rules={[
                {
                  required: true,
                  message: "Please Dock Code",
                },
              ]}
            >
              <Input placeholder="Dock code" />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={24}>
          <Col span={12}>
            <Form.Item
              label="Campus"
              name={"campus"}
              rules={[
                {
                  required: true,
                  message: `Please select campus!`,
                },
              ]}
            >
              <Select
                placeholder={"Select campus"}
                showSearch
                style={{ width: 280 }}
                filterOption={(input, option) =>
                  option.children.toLowerCase().indexOf(input.toLowerCase()) >=
                  0
                }
                labelInValue={true}
              >
                {campuses.map((item, index) => (
                  <Select.Option key={index + "o"} value={item.id}>
                    {item.name}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              label="Latitude,Longitude"
              name="latlong"
              rules={[
                {
                  required: true,
                  message: "Please input lat long",
                },
              ]}
            >
              <Input placeholder="latitude,longitude" />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={24}>
          <Col span={12}>
            <Form.Item
              label="Status"
              name={"status"}
              rules={[
                {
                  required: true,
                  message: "Please select Status",
                },
              ]}
            >
              <Select
                labelInValue={true}
                options={[
                  { text: "Active", value: "active" },
                  { text: "Inactive", value: "inactive" },
                ]}
                placeholder="Select Status"
              />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              label="Type"
              name={"station_type"}
              rules={[
                {
                  required: true,
                  message: "Please select Station Type",
                },
              ]}
            >
              <Select
                labelInValue={true}
                options={Object.values(DOCK_TYPES)}
                placeholder="Select Station Type"
              />
            </Form.Item>
          </Col>
        </Row>
        <Form.Item>
          <Space style={{ display: "flex", justifyContent: "flex-end" }}>
            <Button onClick={onCancel}>Cancel</Button>
            <Button type="primary" htmlType="submit">
              {isUpdate ? "Save" : "Add"}
            </Button>
          </Space>
        </Form.Item>
      </Form>
    </Modal>
  );
}

export default StationModal;
